import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-task",
  "use": "app-icon-task-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-task\"><path d=\"M7.5 3V2a1 1 0 011-1h7a1 1 0 011 1v1h4a1 1 0 011 1v18a1 1 0 01-1 1h-17a1 1 0 01-1-1V4a1 1 0 011-1h4zm0 1.5H4v17h16v-17h-3.5V7h-9V4.5zm1.5-2v3h6v-3H9zm.25 11a.75.75 0 110-1.5h5.5a.75.75 0 110 1.5h-5.5zm0 4a.75.75 0 110-1.5h5.5a.75.75 0 110 1.5h-5.5z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol